import { render, staticRenderFns } from "./FootprintTableSortingSingle.vue?vue&type=template&id=7fbf46c0&scoped=true&"
import script from "./FootprintTableSortingSingle.vue?vue&type=script&lang=js&"
export * from "./FootprintTableSortingSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf46c0",
  null
  
)

export default component.exports